(() => {
  if (window.glgllFoundationInitialized) return;
  window.glgllFoundationInitialized = true;
  const nativeShade = () => document.querySelector('variant-selects input[type="radio"]:checked')?.value || document.querySelector('variant-selects select')?.value || 'Light';
  const refreshShade = () => {
    const value = nativeShade();
    document.querySelectorAll('[data-gaf-shade]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gafShade === value)));
    document.querySelectorAll('[data-gaf-selected-shade]').forEach(label => label.textContent = value);
  };
  const decorateComparisons = () => {
    document.querySelectorAll('.product__media').forEach(media => {
      const image = media.querySelector('img');
      if (!image || !/Reference makeup comparison/i.test(image.alt) || media.querySelector('.gaf-media-labels')) return;
      const labels = document.createElement('div');
      labels.className = 'gaf-media-labels';
      labels.innerHTML = '<span>BEFORE</span><span>AFTER</span>';
      const note = document.createElement('span');
      note.className = 'gaf-media-note';
      note.textContent = 'Reference makeup look · Results vary';
      const overlay = document.createElement('div');
      overlay.className = 'gaf-media-overlay';
      overlay.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:3;display:block;';
      overlay.append(labels, note);
      media.append(overlay);
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gaf-shade]');
    if (!button) return;
    const value = button.dataset.gafShade;
    const radio = [...document.querySelectorAll('variant-selects input[type="radio"]')].find(input => input.value === value);
    if (radio && !radio.disabled) radio.click();
    else {
      const select = document.querySelector('variant-selects select');
      if (select && [...select.options].some(option => option.value === value)) {
        select.value = value;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    refreshShade();
    document.getElementById('gaf-purchase')?.scrollIntoView({behavior:'smooth',block:'start'});
  });
  document.addEventListener('change', event => { if (event.target.closest('variant-selects')) setTimeout(refreshShade, 50); });
  const start = () => { decorateComparisons(); refreshShade(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
